"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var decimal_js_light_1 = require("decimal.js-light");
function formatCurrency(cents, options) {
    cents = cents || 0;
    var dollarString = AutoNumeric.format(new decimal_js_light_1.Decimal(Math.abs(cents)).div(100).toString(), { currencySymbol: "$" });
    return cents < 0 ? formatNegativeCurrency(dollarString, options ? options.negativeSymbol : "(") : dollarString;
}
exports.formatCurrency = formatCurrency;
var formatNegativeCurrency = function (dollars, negativeSymbol) { return negativeSymbol + dollars + (negativeSymbol === "(" ? ")" : ""); };
function formatPercent(fraction, minIntegerDigits, minDecimalDigits, maxDecimalDigits) {
    if (minIntegerDigits === void 0) { minIntegerDigits = 2; }
    if (minDecimalDigits === void 0) { minDecimalDigits = 2; }
    if (maxDecimalDigits === void 0) { maxDecimalDigits = 2; }
    var formatter = new Intl.NumberFormat('en-us', {
        style: 'percent',
        minimumIntegerDigits: minIntegerDigits,
        minimumFractionDigits: minDecimalDigits,
        maximumFractionDigits: maxDecimalDigits
    });
    return formatter.format(fraction || 0);
}
exports.formatPercent = formatPercent;
function formatPercentString(value, decimalPlaces, allowDecimalPadding) {
    if (decimalPlaces === void 0) { decimalPlaces = 5; }
    if (allowDecimalPadding === void 0) { allowDecimalPadding = false; }
    return AutoNumeric.format(AutoNumeric.unformat(value, { decimalPlaces: decimalPlaces, allowDecimalPadding: false }), { decimalPlaces: decimalPlaces, allowDecimalPadding: allowDecimalPadding, currencySymbol: '%', currencySymbolPlacement: 's' });
}
exports.formatPercentString = formatPercentString;
function fractionStringToPercent(fraction, decimalPlaces, allowDecimalPadding) {
    if (decimalPlaces === void 0) { decimalPlaces = 5; }
    if (allowDecimalPadding === void 0) { allowDecimalPadding = false; }
    var extendedFraction = (fraction || '0') + '00';
    var splitExtendedFraction = extendedFraction.split('.');
    if (splitExtendedFraction.length > 1)
        return formatPercentString(splitExtendedFraction[0] + splitExtendedFraction[1].slice(0, 2) + '.' + splitExtendedFraction[1].slice(2, splitExtendedFraction[1].length), decimalPlaces, allowDecimalPadding);
    return formatPercentString(extendedFraction, decimalPlaces, allowDecimalPadding);
}
exports.fractionStringToPercent = fractionStringToPercent;
function integerCentsToStringDollars(value) {
    if (value === null)
        return null;
    if (value % 1 !== 0)
        throw 'value must be an integer';
    var stringValue = String(value);
    var isNegative = stringValue[0] === '-';
    if (isNegative)
        stringValue = stringValue.split('-')[1];
    if (stringValue.length === 1)
        stringValue = '0' + stringValue;
    return AutoNumeric.unformat((isNegative ? '-' : '') + stringValue.substring(0, stringValue.length - 2) + '.' + stringValue.substring(stringValue.length - 2, stringValue.length));
}
exports.integerCentsToStringDollars = integerCentsToStringDollars;
function stringDollarsToIntegerCents(value) {
    if (value === null)
        return null;
    var decimalPortion = value.split('.')[1];
    if (decimalPortion && decimalPortion.length > 2)
        throw 'cannot convert string dollars with more than 2 decimal places';
    var valueInCents = value.replace(/\./g, '') + ((decimalPortion && decimalPortion.length === 1)
        ? '0'
        : (!decimalPortion || decimalPortion.length === 0)
            ? '00'
            : '');
    return parseInt(valueInCents);
}
exports.stringDollarsToIntegerCents = stringDollarsToIntegerCents;
